import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-borrowerdetails',
  templateUrl: './borrowerdetails.component.html',
  styleUrls: ['./borrowerdetails.component.css']
})
export class BorrowerdetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
